import { render, staticRenderFns } from "./RoomSelectButton.vue?vue&type=template&id=242dd032&scoped=true"
import script from "./RoomSelectButton.vue?vue&type=script&lang=js"
export * from "./RoomSelectButton.vue?vue&type=script&lang=js"
import style0 from "./RoomSelectButton.vue?vue&type=style&index=0&id=242dd032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242dd032",
  null
  
)

export default component.exports